/**
 * User-facing copy for browser fetch failures, Supabase network errors, and timeouts.
 * Avoids raw "TypeError: Failed to fetch" in UI.
 */
export function humanizeNetworkOrUnknown(err: unknown): string {
  if (err == null) return "Something went wrong. Please try again.";
  let msg = err instanceof Error ? err.message : String(err);
  msg = msg.replace(/^typeerror:\s*/i, "").trim();
  const lower = msg.toLowerCase();
  if (
    lower === "failed to fetch" ||
    lower.includes("failed to fetch") ||
    lower.includes("load failed") ||
    lower.includes("networkerror") ||
    lower.includes("network request failed") ||
    lower.includes("err_network_changed")
  ) {
    return "We couldn’t reach the server. Check Wi‑Fi or mobile data, wait a moment, then try again.";
  }
  if (lower.includes("aborted") || (err instanceof Error && err.name === "AbortError")) {
    return "The request timed out. Try again with a clearer photo or a stabler connection.";
  }
  if (lower.includes("bad json") || lower.includes("invalid response")) {
    return "The server returned an unexpected response. Please try again.";
  }
  if (
    lower.includes("can't find variable") ||
    lower.includes("cannot read") ||
    lower.includes("is not defined") ||
    lower.includes("is not a function") ||
    lower.includes("referenceerror") ||
    lower.includes("typeerror")
  ) {
    return "Something went wrong. Please refresh the page and try again.";
  }
  return msg.length > 180 ? `${msg.slice(0, 177)}…` : msg;
}

/** PostgREST / Supabase client messages when the browser cannot reach Supabase. */
export function humanizeSupabaseSaveError(raw: unknown): string {
  const s = typeof raw === "string" ? raw : raw instanceof Error ? raw.message : String(raw ?? "");
  const msg = s.replace(/^typeerror:\s*/i, "").trim();
  const lower = msg.toLowerCase();
  if (lower.includes("failed to fetch") || lower.includes("network")) {
    return "Couldn’t save to your account — the connection dropped. Check your network and try again.";
  }
  return msg.length > 200 ? `${msg.slice(0, 197)}…` : msg;
}
